'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_ClientType() {
}
export { $c_Lapp_api_ClientType as $c_Lapp_api_ClientType };
$c_Lapp_api_ClientType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_ClientType.prototype.constructor = $c_Lapp_api_ClientType;
/** @constructor */
function $h_Lapp_api_ClientType() {
}
export { $h_Lapp_api_ClientType as $h_Lapp_api_ClientType };
$h_Lapp_api_ClientType.prototype = $c_Lapp_api_ClientType.prototype;
$c_Lapp_api_ClientType.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lapp_api_ClientType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(0, "app.api.ClientType", ({
  Lapp_api_ClientType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_api_ClientType as $d_Lapp_api_ClientType };
//# sourceMappingURL=app.api.-Client-Type.js.map
